import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const giphy = defineConnector({
  identifier: "giphy",
  name: "Giphy",
  tagLine: "GIF and sticker library",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://(api|upload)\\.giphy\\.com/.*",
  auth: (app) => queryAuth([{ name: "api_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an app to get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Giphy developers dashboard](https://developers.giphy.com/dashboard/), create an app, and copy its API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.giphy.com/v1/gifs/trending?limit=1",
  },
});
